// extracted by mini-css-extract-plugin
export default {"list":"list--_mpql","bullet":"bullet--34yDM","step":"step--1B7cA"};